module.exports = __webpack_public_path__ + "img/quiz_02.7336f4ac.jpg";